import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider, Box, Layout, Notification, Sticky, MediaQuery } from '@deseretbook/react-ui'
import ItemAddedInfo from './ItemAddedInfo'
import ItemAddedCart from './ItemAddedCart'

/**
 * Item Added page container
 * @param {array} props array of objects
 * @returns {function} Component
 */
function ItemAddedContainer(props) {
  const {
    item, order, ...rest
  } = props

  return (
    <ThemeProvider>
      <MediaQuery.TinyOnly>
        {isTiny => (
          <Box padding={1}>
            <Notification type="success" titleContent="Item added to cart" />
            <Layout>
              <Layout.Content>
                <Box paddingVertical={1}>
                  <ItemAddedInfo item={item} product={item.product} />
                </Box>
              </Layout.Content>
              {!!isTiny && (
                <Sticky position="bottom">
                  <Layout.Aside background="main">
                      <ItemAddedCart order={order} isTiny/>
                  </Layout.Aside>
                </Sticky>
              )}
              {!isTiny && (
                <Layout.Aside background="main">
                  <ItemAddedCart order={order} isTiny/>
                </Layout.Aside>
              )}
            </Layout>
          </Box>
        )}
      </MediaQuery.TinyOnly>

    </ThemeProvider>
  )
}

ItemAddedContainer.defaultProps = {
  item: {},
  order: {},
}

ItemAddedContainer.propTypes = {
  // Item added to cart
  item: PropTypes.shape({
    product: PropTypes.shape({})
  }),
  // The order being placed
  order: PropTypes.shape({}),
}

export default ItemAddedContainer